module.exports = __webpack_public_path__ + "static/media/about-truss-1.e26115e2.png";